import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

import ex from "utils/ex";

import LogoButton from './LogoButton';
import DoctorInfo from './DoctorInfo';
import OverviewNavButton from './OverviewNavButton';
import ReportNavButton from './ReportNavButton';
import SimulationNavButton from './SimulationNavButton';
import DrGuideNavButton from './DrGuideNavButton';
import AdviceNavButton from './AdviceNavButton';
import AnalysisNavButton from './AnalysisNavButton';
import KtNavButton from './KtNavButton';
import useNavAction from 'hooks/actions/useNavAction';

import inertTraverse from 'utils/inertTraverse';
import useLogined from 'hooks/app/useLogined';
import './Navbar.css';

export default function Navbar(props) {
  const logined = useLogined();

  const {
    triggered: triggeredOverview,
    onTrigger: onTriggerOverview,
  } = useNavAction('Overview', props);

  const {
    triggered: triggeredReport,
    onTrigger: onTriggerReport,
  } = useNavAction('Report', props);

  const {
    triggered: triggeredSimulation,
    onTrigger: onTriggerSimulation,
  } = useNavAction('Simulation', props);

  const {
    triggered: triggeredDrGuide,
    onTrigger: onTriggerDrGuide,
  } = useNavAction('DrGuide', props);

  const {
    triggered: triggeredAdvice,
    onTrigger: onTriggerAdvice,
  } = useNavAction('Advice', props);

  const {
    triggered: triggeredAnalysis,
    onTrigger: onTriggerAnalysis,
  } = useNavAction('Analysis', props);

  const ref = React.useRef();
  const [selected, setSelected] = React.useState(0);
  React.useEffect(() => {
    const triggers = [
      triggeredOverview,
      triggeredReport,
      triggeredSimulation,
      triggeredDrGuide,
      triggeredAdvice,
      triggeredAnalysis
    ];
    const selected = triggers.findIndex(trigger => trigger);
    setSelected(() => selected);
  }, [triggeredOverview, triggeredDrGuide, triggeredReport, triggeredSimulation, triggeredAdvice, triggeredAnalysis]);

  React.useEffect(() => {
    if (!logined) return;

    const triggers = [
      onTriggerOverview(),
      onTriggerReport(),
      onTriggerSimulation(),
      onTriggerDrGuide(),
      onTriggerAdvice(),
      onTriggerAnalysis()
    ];

    const onKeyDown = (e) => {
      if (!inertTraverse(ref.current)) return;
      switch (e.key) {
        case 'ArrowUp': {
          const nextSelected = (triggers.length + selected - 1) % triggers.length;
          triggers[nextSelected]();
          document.activeElement?.blur();
          return;
        }
        case 'ArrowDown': {
          const nextSelected = (selected + 1) % triggers.length;
          triggers[nextSelected]();
          document.activeElement?.blur();
          return;
        }
        default:
          return;
      }
    }

    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [logined, onTriggerOverview, onTriggerDrGuide, onTriggerReport, onTriggerSimulation, selected, onTriggerAdvice, onTriggerAnalysis]);

  if (!logined) return null;

  return (
    <div
      {...ex('Navbar', props)}
      {...{ ref }}
    >
      <div>
        <LogoButton />
      </div>
      <div>
        <OverviewNavButton {...props} />
        <ReportNavButton {...props} />
        <SimulationNavButton {...props} />
        <DrGuideNavButton {...props} />
        <AdviceNavButton {...props} />
        <AnalysisNavButton {...props} />
      </div>
      <div>
        <DoctorInfo />
      </div>
      <div>
      </div>
    </div>
  );
}
